import { type RefObject, useEffect } from "react";
import type { gsap } from "gsap";

/**
 * Play or pause and reset a timeline based on the isActive prop.
 * Use this when the timeline is still in view, but needs to be reset. Often used within tabs.
 */
export function useTimelinePlayback(timeline: RefObject<gsap.core.Timeline | undefined>, isActive: boolean) {
  useEffect(() => {
    if (isActive) {
      timeline.current?.play();
    } else {
      timeline.current?.progress(0).pause();
    }
  }, [isActive, timeline]);
}
